import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  initiateBudgetForEdit,
  setCurrentBudgetLoading,
} from "../budgetsSlice";
import { getBudgetByIdThunk } from "@/store/budgets/thunks/getBudgetByIdThunk";

export const initiateBudgetByIdThunk = createAsyncThunk(
  "budgets/initiateBudgetById",
  async (id: string, { dispatch }) => {
    dispatch(setCurrentBudgetLoading(true));

    const response = await dispatch(getBudgetByIdThunk(id)).unwrap();

    if (response) {
      dispatch(initiateBudgetForEdit(response));
    }
  },
);
